import api, { apiInternal } from '../api';

export async function getPatgames(id) {
  const { data } = await api.post(`${apiInternal}/establishment/getPatgamesList`, {esta_id: id});
  return data;
}